
import pxstream from '../services/pxstream'

export default {
  install: (app) => {
    app.config.globalProperties.$pxstream = pxstream
    app.provide('pxstream', pxstream)
  }
}